export default {"src":"/_next/static/media/quick-order.f596f564.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};